import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { setValuesSelectorOpen } from '../../../../../untidy/redux/actions/actions';
import { getValuesSelectorOpen } from '../../../../../untidy/redux/selectors';
import { ValuesSelectorMain } from './main';
import Menu from 'react-burger-menu/lib/menus/slide';
import { usePushGtmEvent } from '@upright/ui/common/generic/components/google-tag-manager/use-push-gtm-event';
import { CustomGtmEvent } from '@upright/ui/common/generic/components/google-tag-manager/use-push-gtm-event/payloads';

interface Props {
  pageWrapId?: string;
  outerContainerId: string;
}

export function ValuesSelectorSidebar(props: Props) {
  const open = useSelector(getValuesSelectorOpen);
  const pushGtmEvent = usePushGtmEvent();

  const dispatch = useDispatch();
  return (
    <StyledMenu
      {...props}
      width={362}
      styles={styles}
      customBurgerIcon={false}
      customCrossIcon={false}
      right
      isOpen={open}
      onStateChange={(state: any) => {
        if (open !== state.isOpen) {
          dispatch(setValuesSelectorOpen(state.isOpen));
        }
        if (state.isOpen) {
          pushGtmEvent({
            event: CustomGtmEvent.VALUE_SET_OPEN,
          });
        }
      }}
    >
      <ValuesSelectorMain close={() => dispatch(setValuesSelectorOpen(false))} />
    </StyledMenu>
  );
}

const StyledMenu = styled(Menu)`
  border-left: 2px solid #dddddd;
  max-width: 100vw;
`;

const styles = {
  bmBurgerButton: {
    position: 'fixed',
    right: '0',
    top: '50vh',
    // VS: Not sure why the translate needs to be 60% instead of 50%
    transform: 'rotate(-90deg) translate(60%, 0)',
    transformOrigin: 'right bottom 0px',
    zIndex: '50',
  },
  bmBurgerBars: {
    background: '#dddddd',
  },
  bmCrossButton: {
    height: '24px',
    width: '24px',
  },
  bmCross: {
    background: '#bdc3c7',
  },
  bmMenu: {
    backgroundColor: 'white',
    padding: `0px`,
  },
  bmMorphShape: {},
  bmItemList: {},
  bmItem: {},
  bmOverlay: {
    background: 'rgba(0, 0, 0, 0.1)',
  },
};
